import { ApiTab } from '@/Enums/Attribution/ApiTabs.enum';
import { IParsedCurrentWhitelabel, IWhitelabel } from '@/Interfaces/Whitelabels/Whitelabel.interface';

export default class CurrentWhitelabelService {
  public static get defaultCurrentWhitelabel(): IParsedCurrentWhitelabel {
    const whitelabel = {
      id: 0,
      domain: '',
      domainExternal: '',
      mainLogo: '',
      favicon: '',
      sidebarLogo: '',
      sidebarBg: '',
      sidebarTextColor: '',
      loginBg: '',
      loginTextDark: false,
      buttonBg: '',
      forecastByPub: false,
      showCpm: false,
      whitelabelName: '',
      settings: {} as IParsedCurrentWhitelabel['settings'],
      isDefault: false,
      extendedAudiences: false,
      extendedReportingDashboardFilters: false,
      showLineItemAlternativeId: false,
      showCampaignAlternativeId: false,
      showAdvertiserAlternativeId: false,
      requiresCampaignApproval: false,
      billingModel: null,
      visibleReportingScreenTabs: [] as IParsedCurrentWhitelabel['visibleReportingScreenTabs'],
      visibleReportBuilderBeeswaxDimensions: [] as IParsedCurrentWhitelabel['visibleReportBuilderBeeswaxDimensions'],
      showClientSpendInReportingDashboards: false,
      showReachInForecaster: true,
      visibleForecasterChannels: [],
      visibleCampaignManagementChannels: [],
      hasGamAccount: false,
      beeswaxImpressionsByTypeTableTabs: [] as IParsedCurrentWhitelabel['beeswaxImpressionsByTypeTableTabs'],
      visibleReportBuilderTabs: [] as IParsedCurrentWhitelabel['visibleReportBuilderTabs'],
      visibleInsightsTabs: Object.values(ApiTab),
      defaultOmnichannelGripReport: null,
      defaultAudioGridReport: null,
      dv360CampaignManagement: false,
      isZendeskWidgetEnabled: false,
      hideRequestAudienceButton: false,
      hideRequestProductButton: false,
      hideProductSelectionCard: false,
      hideAiReporting: false,
      hideAiForecaster: false,
      hideAiPacing: false,
      hideCtrInDeliveryImpressionsByType: false,
      hideAudioCompletePercentInDeliveryImpressionsByType: false,
      hideClicksInAttributionImpressionsByType: false,
      showBidCpmGuidance: false,
      showBidCpmGuidanceForecaster: false,
    };
    return { ...whitelabel };
  }

  public static formatCurrentWhitelabelResponse(data: IWhitelabel): IParsedCurrentWhitelabel {
    if (!data) return this.defaultCurrentWhitelabel;
    return {
      id: data.id,
      domain: data.domain,
      domainExternal: data.domain_external,
      mainLogo: data.main_logo,
      sidebarLogo: data.sidebar_logo || data.main_logo,
      sidebarBg: data.sidebar_bg,
      sidebarTextColor: data.sidebar_text_color,
      loginBg: data.login_bg,
      loginTextDark: !!data.login_text_dark,
      buttonBg: data.button_bg,
      showCpm: !!data.show_cpm,
      isDefault: !!data.is_default,
      favicon: data.favicon,
      whitelabelName: data.name,
      forecastByPub: !!data.forecast_by_pub,
      extendedAudiences: !!data.extended_audiences,
      extendedReportingDashboardFilters: !!data.extended_reporting_dashboard_filters,
      showLineItemAlternativeId: !!data.show_line_item_alternative_id,
      showCampaignAlternativeId: !!data.show_campaign_alternative_id,
      showAdvertiserAlternativeId: !!data.show_advertiser_alternative_id,
      settings: data.settings,
      requiresCampaignApproval: !!data.requires_campaign_approval,
      billingModel: data.billing_model,
      visibleReportingScreenTabs: data.visible_reporting_screen_tabs,
      visibleReportBuilderBeeswaxDimensions: data.visible_report_builder_beeswax_dimensions,
      showClientSpendInReportingDashboards: !!data.show_client_spend_in_reporting_dashboards,
      showReachInForecaster: !!data.show_reach_in_forecaster,
      visibleForecasterChannels: data.visible_forecaster_channels,
      visibleCampaignManagementChannels: data.visible_campaign_management_channels ?? [],
      hasGamAccount: !!data.has_gam_account,
      beeswaxImpressionsByTypeTableTabs: data.beeswax_impressions_by_type_table_tabs,
      visibleReportBuilderTabs: data.visible_report_builder_tabs,
      visibleInsightsTabs: data.visible_insights_tabs,
      defaultOmnichannelGripReport: data.default_omnichannel_grid_report,
      defaultAudioGridReport: data.default_audio_grid_report,
      dv360CampaignManagement: !!data.dv360_campaign_management,
      isZendeskWidgetEnabled: data.is_zendesk_widget_enabled !== false,
      hideRequestAudienceButton: !!data.hide_request_audience_button,
      hideRequestProductButton: !!data.hide_request_product_button,
      hideProductSelectionCard: !!data.hide_product_selection_card,
      hideAiReporting: !!data.hide_ai_reporting,
      hideAiForecaster: !!data.hide_ai_forecaster,
      hideAiPacing: !!data.hide_ai_pacing,
      hideCtrInDeliveryImpressionsByType: !!data.hide_ctr_in_delivery_impressions_by_type,
      hideAudioCompletePercentInDeliveryImpressionsByType:
        !!data.hide_audio_complete_percent_in_delivery_impressions_by_type,
      hideClicksInAttributionImpressionsByType: !!data.hide_clicks_in_attribution_impressions_by_type,
      showBidCpmGuidance: !!data.show_bid_cpm_guidance,
      showBidCpmGuidanceForecaster: !!data.show_bid_cpm_guidance_forecaster,
    };
  }
}
